"use client";

import {TableBlock} from "@/lib/interfaces/blocks";
import React, {MutableRefObject, useEffect, useRef} from "react";
import { sanitiseHtml } from "@/lib/helpers/sanitise";

interface TableProps {
    block: TableBlock
}
export default function Table({block}: TableProps) {
    const tableHtml = block.content.content.trim();
    let ref = useRef<null|HTMLDivElement>(null);
    useEffect(() => {
        let div = ref.current;
        if (ref && div) {
            let table = div.querySelector('table');
            if (table) {
                table.setAttribute('width', '100%');
                table.classList.add('eo-table');
                if (block.content.header_row) {
                    let firstRow = table.querySelector('tr:first-child');
                    if (firstRow) {
                        const td = firstRow.querySelectorAll('td');
                        for(let i=0; i<td.length; i++) {
                            const attributes = td[i].attributes;
                            const th = document.createElement('th');
                            th.innerText = td[i].innerText;
                            for(let a=0; a<attributes.length; a++) {
                                th.setAttribute(attributes[a].name, attributes[a].value);
                            }
                            firstRow.removeChild(td[i]);
                            firstRow.appendChild(th);
                        }
                        firstRow.classList.add('table-header');
                    }
                }
            }
        }
    }, [ref, block.content.header_row]);
    return (
        <div ref={ref} dangerouslySetInnerHTML={{__html: sanitiseHtml(tableHtml)}}></div>
    )
}